import React, { Fragment, useCallback, useRef, forwardRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import Modal from "components/common/modal";
import { livefeedStyle } from "components/pages/livefeed/defaultstate";
import * as a from "actions/livefeedapi";
import update from "immutability-helper";
import { setLivefeedName } from "actions/livefeed";
import { generateSlideName } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'

const LivefeedModal = forwardRef((props, ref) => {
    // passedProps
    const {
        livefeedSlides, nodeMap, creatorEmail, editorMode, savingType, dispatch,
        nullLocationSlides, slideShowDontHaveMapAPI, livefeedName, isCreateMode, router, editorKey
    } = props;
    const livefeedModal = useRef(null);

    useImperativeHandle(ref, () => ({
        open: () => {
            livefeedModal.current.open()
        }
    }));
    //-------------------------------------------Function create schema before submit -----------------------------------
    const createLivefeedSchema = useCallback(
        () => {
            // array of locations, each object in array is the locations of each slide
            let processedLivefeedSlides = livefeedSlides.slice();
            for (let i = 0; i < processedLivefeedSlides.length; i++) {
                processedLivefeedSlides = update(processedLivefeedSlides, {
                    [i]: {
                        // clear historyEntities on every slide
                        historyEntities: {
                            $set: [
                                {
                                    id: null
                                }
                            ]
                        },
                        logoState: {
                            file: { $set: null }
                        }
                    }
                });
            }
            return processedLivefeedSlides;
        },
        [livefeedSlides]
    );

    //------------------------------------------------------ SUBMIT LIVEFEED -----------------------------------------
    const submitLivefeed = useCallback(
        () => {
            if (livefeedName) {
                let locations = [];
                livefeedSlides.slice().map(slide => {
                    if (slide.slideType !== "locationsList") {
                        locations = locations.concat(slide.floorplanOptions.locationsID);
                    }
                });
                let refinedLocationsID = locations.filter(id => nodeMap[id])
                let uniqueLocations = new Set(refinedLocationsID)
                // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed

                let locationsArr = [...uniqueLocations]
                let locationsArrObj = []
                for (let i = 0, n = locationsArr.length; i < n; i++) {
                    let node = nodeMap[locationsArr[i]]
                    locationsArrObj.push({ locationId: locationsArr[i], locationName: node.info.name })
                }
                let livefeedData = {
                    name: livefeedName,
                    owner: creatorEmail,
                    locations: locationsArrObj,
                    data: {
                        timestamp: Date.now(),
                        containerHeight: livefeedStyle.containerHeight,
                        containerWidth: livefeedStyle.containerWidth,
                        livefeedSlides: createLivefeedSchema()
                    }
                };
                //-------------------------- create dispatch -------------------------

                if (
                    (editorMode === "createLivefeed" && nullLocationSlides.length === 0 && slideShowDontHaveMapAPI.length === 0) ||
                    // in case editorMode is createTemplate, but user choose to save as livefeed
                    editorMode === "createTemplate" ||
                    // in case user edits livefeed, but then  choose to save as a new livefeed
                    savingType === "livefeed"
                ) {
                    let subscribers = [creatorEmail];
                    dispatch(
                        a.createLivefeed(livefeedData, subscribers, () => {
                            livefeedModal.current.close();
                            router.push({
                                pathname: "/livefeed"
                            });
                        })
                    );
                }
                //-------------------------- editor dispatch (AKA update) -------------------------
                else if (editorMode === "editLivefeed" && savingType === "update") {
                    livefeedData.key = editorKey;
                    dispatch(
                        a.updateLivefeed(livefeedData, () => {
                            livefeedModal.current.close();
                            router.push({
                                pathname: "/livefeed"
                            });
                        })
                    );
                }
            }
        },
        [
            createLivefeedSchema, creatorEmail, dispatch, editorKey, editorMode, livefeedName,
            livefeedSlides, nodeMap, nullLocationSlides.length, slideShowDontHaveMapAPI.length, router, savingType
        ]
    );


    const liveFeedNameChangeHandler = useCallback(
        e => {
            var name = e.target.value;
            dispatch(setLivefeedName(name));
        },
        [dispatch]
    );
    const isLivefeedSubmittable = livefeedName && nullLocationSlides.length === 0 && slideShowDontHaveMapAPI.length === 0;
    return (

        <Modal
            ref={livefeedModal}
            clickButton={() => (isLivefeedSubmittable ? submitLivefeed() : null)}
            header={`${isCreateMode ? "Save as Livefeed" : "Update Livefeed"}`}
            buttonText={`${isCreateMode ? "Save" : "Confirm"}`}
            buttonClass={isLivefeedSubmittable ? "btn-success" : "btn-success disabled"}
            entry={null}
        >
            <div className="save-form">
                <div>
                    <span className="input-label">Livefeed Name:</span>
                    <input
                        type="text"
                        value={livefeedName}
                        onChange={e => {
                            liveFeedNameChangeHandler(e);
                        }}
                        required
                    />
                </div>
                <div>
                    {/* If savingType==="livefeed" then check nullLocationSlides and slideShowDontHaveMapAPI */}

                    {nullLocationSlides.length === 0 && slideShowDontHaveMapAPI.length === 0 ? (
                        <span className="save-note good">Your Livefeed is ready to be {isCreateMode ? "created" : "updated"}:</span>
                    ) : (
                            <span className="save-note bad">Please fulfil all the requirements before saving your Livefeed</span>
                        )}
                    {nullLocationSlides.length === 0 ?
                        <div className="save-point good">
                            <i className="material-icons">&#xe5ca;</i>You slides have locations.
                        </div>
                        :
                        <Fragment>
                            <div className="save-point bad">
                                <i className="material-icons">&#xe002;</i>You haven't chosen Senzolive location
                            {nullLocationSlides.length > 1 ? "s " : " "}on the following slide.
                             </div>
                            <br />
                            <ul>
                                {nullLocationSlides.map((slide, index) =>
                                    <li key={index}>{generateSlideName(livefeedSlides, slide)}</li>
                                )}
                            </ul>
                        </Fragment>
                    }

                    {slideShowDontHaveMapAPI.length === 0 ?
                        <div className="save-point good">
                            <i className="material-icons">&#xe5ca;</i>You slides have Steerpath Map API.
                        </div>
                        :
                        <Fragment>
                            <div className="save-point bad">
                                <i className="material-icons">&#xe002;</i>You haven't entered Steerpath Map API
                            {slideShowDontHaveMapAPI.length > 1 ? "s " : " "}on the following slide.
                             </div>
                            <br />
                            <ul>
                                {slideShowDontHaveMapAPI.map((slide, index) =>
                                    <li key={index}>{generateSlideName(livefeedSlides, slide)}</li>
                                )}
                            </ul>
                        </Fragment>
                    }
                </div>
            </div>
        </Modal>
    );
});

LivefeedModal.propTypes = {
    livefeedSlides: PropTypes.array.isRequired,
    nodeMap: PropTypes.object.isRequired,
    creatorEmail: PropTypes.string.isRequired,
    editorMode: PropTypes.string,
    savingType: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    nullLocationSlides: PropTypes.array.isRequired,
    slideShowDontHaveMapAPI: PropTypes.array.isRequired,
    livefeedName: PropTypes.string.isRequired,
    isCreateMode: PropTypes.bool.isRequired,
    router: PropTypes.object.isRequired
};

export default LivefeedModal;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/TopMenuContainer/LivefeedModal/index.jsx